var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.visible)?_c('div',{staticClass:"eva-status-chip"},[_c('v-icon',{staticClass:"mr-1",attrs:{"size":"20","color":_vm.color}},[_vm._v(_vm._s(_vm.icon))]),_c('span',[_vm._v(_vm._s(_vm.statusText))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }